import NodeBufferTank from './node-buffer-tank';

export default NodeBufferTank;
